import type { LcSettlementEntriesParams, LcSettlementParams } from '@/api/lcSettlement'

export const lcSettlementQueryKeys = {
  all: ['admin', 'lc-settlement'] as const,
  summary: (params: LcSettlementParams) => ['admin', 'lc-settlement', 'summary', params] as const,
  entries: (params: LcSettlementEntriesParams) => ['admin', 'lc-settlement', 'entries', params] as const,
}
